module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./SelectStoreTypeView.js"));
	}, "ViewPackageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ViewPackageView!./src/pages/Register/SelectStoreType/SelectStoreTypeView.js
// module id = 1333
// module chunks = 418